import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Body1 } from '@ui/Typography'
import { Modal } from '@ui/components/Modal'

import { useFundingNav } from '@hooks/useFundingNav'

import { useDepositTracker } from '@analytics/amplitude/deposit'

interface InsufficientFundsModalProps {
  navigationUrl: string
}

export const UnableToCheckoutModal: BaseModalType = ({ close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Subscriptions.Why I can’t checkout?')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <Body1>
            {t(
              'Subscriptions.To start trading, you need to subscribe to at least one Trading Platform'
            )}
          </Body1>
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}

export const InsufficientFundsModal: BaseModalType<InsufficientFundsModalProps> = ({
  navigationUrl,
  close,
}) => {
  const { t } = useTranslation()
  const { navigateToFunding } = useFundingNav()
  const tracker = useDepositTracker()

  return (
    <Modal>
      <Modal.Header>{t('Subscriptions.Insufficient Funds!')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <Body1>
            {t(
              'Subscriptions.You need to have funds in your trading account to fund the subscription'
            )}
          </Body1>
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            close()
            tracker.start({ entry_point: 'subscriptions' })
            navigateToFunding(navigationUrl)
          }}
        >
          {t('Subscriptions.Add Funds')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
